import React from 'react';
import PropTypes from 'prop-types';

export default class DownArrow extends React.Component {
	render() {
		const { fill } = this.props;
		return (
			<svg style={{paddingRight : 3}} width="16px" height="16px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<g id="icons8-circled-down-right" transform="translate(14.000000, 14.000000) scale(1, -1) rotate(-135.000000) translate(-14.000000, -14.000000) ">
					<path d="M28,14 C28,21.7308 21.7308,28 14,28 C6.2692,28 0,21.7308 0,14 C0,6.2692 6.2692,0 14,0 C21.7308,0 28,6.2692 28,14 Z" id="Path" fill={fill} />
					<polygon id="Path" fill="#FFFFFF" points="19.6602 19.4439 10.7513 18.4541 18.6704 10.535"/>
					<polygon id="Path" fill="#FFFFFF" points="15.0962 17.0786 7.6727 9.6523 9.6523 7.6727 17.0786 15.099"/>
				</g>
			</svg>
		);
	}
}

DownArrow.propTypes = {
	fill: PropTypes.string.isRequired,
};

